import { Button, Container, Flex, Link, Text } from "@chakra-ui/react";
import Image from "next/image";
import React, { useEffect, useState } from "react";

export default function Brochure() {
    const [screenSize, getDimension] = useState({
        winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
        winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
    });

    const setDimensions = () => {
        getDimension({
            winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
            winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener("resize", setDimensions);

        return () => {
            window.removeEventListener("resize", setDimensions);
        };
    }, [screenSize]);

    const icons = [
        { imgUrl: "https://media.grupoguia.mx/assets/home-page/icons/icon-check-typ.svg" },
    ];

    return (
        <Container
            maxW="8xl"
            {...(screenSize.winWidth <= 768 && { paddingInline: "0" })}
            paddingTop="8rem"
            paddingBottom="6rem"
        >
            <Flex justifyContent="center" flexDirection="column" alignItems="center">
                <Image src={icons[0].imgUrl} width="186" height="186" alt="icon" />
                <Text
                    marginBottom="2rem"
                    fontSize={{ base: "xl", md: "2xl" }}
                    fontWeight="700"
                    textAlign="center"
                >
                    ¡Gracias por descargar nuestro brochure!
                </Text>
                <Button
                    width={{ base: "240px", md: "282px" }}
                    height="44px"
                    mt={2}
                    py={6}
                    px={2}
                    rounded="full"
                    color="#000"
                    size="sm"
                    right={0}
                    _active={{ bg: "brand.500" }}
                    aria-label="Comenzar requerimiento"
                    bgColor="brand.500"
                    onClick={(e) => {
                        e.preventDefault();
                        window.history.go(-1);
                    }}
                    _hover={{
                        textDecoration: "none",
                        color: "#000",
                        bg: "brand.500",
                    }}
                    asChild
                >
                    <Link>Regresar a la propiedad</Link>
                </Button>
            </Flex>
        </Container>
    );
}
